import { render } from "./Status.vue?vue&type=template&id=1119ea01&scoped=true&bindings={\"status\":\"options\",\"ar\":\"options\",\"fromUpload\":\"options\"}"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=1119ea01&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1119ea01"

export default script